import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { OutlineArrowRight } from '../icons/outline-arrow-right';

import styles from './breadcrumb.module.scss';

export type BreadcrumbObject = {
  href: string;
  label: string;
};

type BreadcrumbProps = {
  breadcrumbs: BreadcrumbObject[];
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ breadcrumbs }) => {
  const navigate = useNavigate();

  const filteredBreadcrumbs =
    breadcrumbs.length > 3
      ? breadcrumbs.filter((_, index) => index >= breadcrumbs.length - 2)
      : breadcrumbs.slice(1);

  const firstBreadcrumb = breadcrumbs.length > 0 ? breadcrumbs[0] : null;

  return (
    <div className={styles.breadcrumb}>
      {firstBreadcrumb && (
        <>
          <Link
            className={styles.crumb}
            to={firstBreadcrumb.href}
          >
            {firstBreadcrumb.label}
          </Link>
          {breadcrumbs.length > 1 && <OutlineArrowRight />}
        </>
      )}
      {filteredBreadcrumbs.length < breadcrumbs.length - 1 && (
        <>
          <span>...</span>
          <OutlineArrowRight />
        </>
      )}

      {filteredBreadcrumbs.map(({ href, label }, index) => (
        <React.Fragment key={`${label}_${index}`}>
          <div
            className={styles.crumb}
            onClick={() => {
              if (index === filteredBreadcrumbs.length - 1) return;
              navigate(href);
            }}
          >
            {label}
          </div>
          {index !== filteredBreadcrumbs.length - 1 && <OutlineArrowRight />}
        </React.Fragment>
      ))}
    </div>
  );
};
